import styled from "styled-components";
// @flow
import React, { PureComponent } from "react";
import { noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";

import Icon from "../../_static/Icons";
import { alert } from "../../_static/Icons/icons";

import buildColor from "../../_static/ColorPalette";
import { RaceAlertsRow } from "./styled-components";
import Toggle from "../../_atom/Toggle";
import { buildText } from "../../_atom/Text";

type Props = {
  isOn: boolean,
  raceNumber?: string,
  showTopBorder: boolean,
  showBottomBorder: boolean,
  onToggleClick: NullaryFn<mixed>
};

const Text = styled(
  buildText({
    bold: false,
    fontSize: 12,
    color: buildColor("grey", "900")
  })
)`
  margin-left: 8px;
`;

export default class RaceAlerts extends PureComponent<Props> {
  static defaultProps = {
    isOn: false,
    raceNumber: "",
    showTopBorder: true,
    showBottomBorder: true,
    onToggleClick: noop
  };

  render() {
    return (
      <RaceAlertsRow
        topBorder={this.props.showTopBorder}
        bottomBorder={this.props.showBottomBorder}
      >
        <div>
          <Icon icon={alert} color={buildColor("grey", "900")} size={16} />
          <Text>
            Alerts for race
            {this.props.raceNumber && ` - R${this.props.raceNumber}`}
          </Text>
        </div>
        <Toggle on={this.props.isOn} onClick={this.props.onToggleClick} />
      </RaceAlertsRow>
    );
  }
}
